<template>
    <div id="search" class="search-right" data-spm="search-box">
        <input type="text" 
            class="search-input left" 
            :value="d_val"  
            data-val="key" 
            @focus="focus"
            @blur="blur"
            @keydown="keydown"
            ref="inputRef"
        >
        <span class="search-btn" @click="onSearch"><i class="search-icon icon"></i></span>
        <form target="" style="display:none;width:0;height:0"></form>
    </div>
</template>

<script>
var storage = window.localStorage || false
import { getHotSearch } from '@/request/request'

export default{
    name: 'search',
    data(){
        return {
            d_val: '',
            queryType: 'edit',
            search_host: "//search.sohu.com/",
        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        async fetchData() {
            try {
                if (storage && storage.getItem("search_words")) {//有数据就直接拿来用
                    var data = JSON.parse(storage.getItem("search_words"));
                    var now = new Date().getTime();
                    if (data && data.words && data.outtime && now < data.outtime) {
                        this.selectWord(data.words)
                        return;
                    }
                }
                const res = await getHotSearch()
                if(res?.status == 1 && res?.data?.length) {
                    var data = {
                        outtime: new Date().getTime() + 1000 * 60 * 10,
                        words: res.data
                    }
                    storage.setItem("search_words", JSON.stringify(data));
                    this.selectWord(res.data)
                }
            } catch (error) {
                console.log('搜索热词',error)
            }
        },
        //随机取一个热词
        selectWord(wordsList) {
            if(!wordsList || !wordsList.length)return
            let randomWord = wordsList[Math.floor(Math.random() * wordsList?.length)];
            if(randomWord){
                this.d_val = "大家都在搜：" + randomWord;
            }
        },
        onSearch() {
            var spm = ''
            var spmCode = ''
            if (window.sohuSpm) {
                spm = window.sohuSpm.getCodes()
                spmCode = spm.a + '.' + spm.b + '.' + 'search-box' + '.' + 1 + '.' + spm.e
            }
            let q = this.$refs.inputRef && this.$refs.inputRef.value
            let url = ''
            if (q == this.d_val) {
                this.queryType = "hot-query";
                q = q.replace("大家都在搜：", "");
            }
            if (q == '') {
                url = this.search_host + '?spm=' + spmCode;
            } else {
                url = [this.search_host,"?keyword=", window.encodeURIComponent(q),"&source=article&queryType=",this.queryType,"&ie=utf8","&spm=",spmCode].join("");
            }
            window.open(url);
        },
        focus(ev) {
            window.sohuSpm?.sendAction({ acode:8103 })
            var val = this.$refs.inputRef && this.$refs.inputRef.value
            if (val == this.d_val) {
                ev.currentTarget.value = ""
            }
        },
        blur() {
            setTimeout(()=>{
                this.$refs.inputRef.value = this.d_val
            }, 200);
        },
        keydown (ev) {
            if (ev.keyCode == 13) {
                this.onSearch()
            }
        }
    }
}
</script>
<style lang="less" scoped>
/* search-right */
.search-right{height:36px;margin:0 auto 10px;margin-left: 20px;}
.search-right .search-input{width:236px;height:34px;color:#999;font-size:14px;border:1px #C0C0C0 solid;border-right:0;line-height:34px;padding-left:10px;float:left;border-radius:2px 0 0 2px;box-sizing: content-box;}
.search-right .search-input:focus{color:#191919;}
.search-right .search-btn{float:left;cursor:pointer;width:53px;height:36px;display:inline-block;background:#fdd000;text-align:center;}
.search-right .search-icon{width:20px;height:20px;overflow:hidden;margin-top:8px;background:url(../../images/search_icon_new.png) no-repeat 0 0;background-size: 20px 20px;}
.search-right .search-btn:hover{background:#ffba00;}
</style>
